<cw-ci-data-table #scanResultsDataTable
  tileTitle="Scan Results"
  refreshToolTip="Reload scan results list"
  defaultSortField="created_at"
  defaultSortDirection="desc"
  [isSelectable]="isSelectable"
  (addHandler)="executeScan($event)"
  (loadItemsHandler)="loadScanResults($event)"
  (selectHandler)="selectScanResult($event)"
  [items]="scanResultsList">

  <cw-ci-table-column columnName="scanConfigurationName" columnTitle="Scan Configuration" sortField="scan_configuration_name"></cw-ci-table-column>
  <cw-ci-table-column columnName="scanConfigurationType" columnTitle="Scan Type" sortField="scan_configuration_type"></cw-ci-table-column>
  <cw-ci-table-column columnName="createdAt" columnTitle="Scan Timestamp" sortField="created_at" [output]="createdTemplate"></cw-ci-table-column>
  <ng-template let-element #createdTemplate>{{element.createdAt | date:'short'}}</ng-template>
</cw-ci-data-table>